import { useQuery } from '@tanstack/react-query';
import type { ClientProfile } from '@his/shared';
import { get } from '@/lib/api';
import { RecordState } from '@/components/ui/record-state';
import { NewTicketForm } from '../desk/NewTicketPage';
import { CLIENT_DESK } from '../desk/desk-api';

export function ClientNewTicketPage() {
  const profile = useQuery({
    queryKey: ['client-profile'],
    queryFn: () => get<ClientProfile>('/client/me'),
  });

  if (!profile.data) return <RecordState error={profile.error} missing={profile.isSuccess} />;
  return (
    <NewTicketForm
      endpoints={CLIENT_DESK}
      listPath="/client/tickets"
      initialCategory="general"
      tenantChoices={profile.data.labs.map((lab) => ({ id: lab.tenantId, name: lab.name }))}
    />
  );
}
